<div
  class="market-data-attributes"
  *ngIf="(marketDataSpecifications | resultsHeader: false).length"
>
  <clr-tree>
    <clr-tree-node
      [(clrExpanded)]="marketDataExpanded"
      *ngFor="let attribute of marketDataSpecifications | resultsHeader: true"
    >
      {{ attribute.longName }}
      <clr-tree-node
        *ngFor="
          let attribute of marketDataSpecifications | resultsHeader: false
        "
      >
        <div style="display: block; float: right; margin-right: 0.5rem">
          {{ attribute.longName }}
        </div>
      </clr-tree-node>
    </clr-tree-node>
  </clr-tree>
</div>
